const { createSelector } = require("reselect");

const selectCreateTransaction = (state) =>
  state["marketplace.marketTransaction"].create;

const createTransaction = () =>
  createSelector([selectCreateTransaction], (crt) => crt.data);

const createTransactionError = () =>
  createSelector([selectCreateTransaction], (crt) => crt.error);

const createTransactionLoading = () =>
  createSelector([selectCreateTransaction], (crt) => crt.loading);

const selectGetInvoice = (state) =>
  state["marketplace.marketTransaction"].invoice;

const getInvoice = () =>
  createSelector([selectGetInvoice], (show) => show.data);

const getInvoiceError = () =>
  createSelector([selectGetInvoice], (show) => show.error);

const getInvoiceLoading = () =>
  createSelector([selectGetInvoice], (show) => show.loading);

const selectGetTransactions = (state) =>
  state["marketplace.marketTransaction"].transactions;

const getTransactions = () =>
  createSelector([selectGetTransactions], (show) => show.data);

const getTransactionsError = () =>
  createSelector([selectGetTransactions], (show) => show.error);

const getTransactionsLoading = () =>
  createSelector([selectGetTransactions], (show) => show.loading);

const selectGetTransaction = (state) =>
  state["marketplace.marketTransaction"].transaction;

const getTransaction = () =>
  createSelector([selectGetTransaction], (show) => show.data);

const getTransactionError = () =>
  createSelector([selectGetTransaction], (show) => show.error);

const getTransactionLoading = () =>
  createSelector([selectGetTransaction], (show) => show.loading);

const selectUpdateAddress = (state) =>
  state["marketplace.marketTransaction"].update;

const updateAddress = () =>
  createSelector([selectUpdateAddress], (updt) => updt.data);

const updateAddressError = () =>
  createSelector([selectUpdateAddress], (updt) => updt.error);

const updateAddressLoading = () =>
  createSelector([selectUpdateAddress], (updt) => updt.loading);

const selectCartCheckout = (state) =>
  state["marketplace.marketTransaction"].checkout;

const cartChackout = () =>
  createSelector([selectCartCheckout], (checkout) => checkout.data);

const cartChackoutError = () =>
  createSelector([selectCartCheckout], (checkout) => checkout.error);

const cartChackoutLoading = () =>
  createSelector([selectCartCheckout], (checkout) => checkout.loading);

const selectTransactionDelivery = (state) =>
  state["marketplace.marketTransaction"].transaction;

const transactionDelivery = () =>
  createSelector([selectTransactionDelivery], (checkout) => checkout.data);

const transactionDeliveryError = () =>
  createSelector([selectTransactionDelivery], (checkout) => checkout.error);

const transactionDeliveryLoading = () =>
  createSelector([selectTransactionDelivery], (checkout) => checkout.loading);

const selectDeliveryPriceList = (state) =>
  state["marketplace.marketTransaction"].deliveryPriceList;

const deliveryPriceList = () =>
  createSelector([selectDeliveryPriceList], (delivery) => delivery.data);

const deliveryPriceListError = () =>
  createSelector([selectDeliveryPriceList], (delivery) => delivery.error);

const deliveryPriceListLoading = () =>
  createSelector([selectDeliveryPriceList], (delivery) => delivery.loading);

const selectDeliveryProvidersList = (state) =>
  state["marketplace.marketTransaction"].deliveryProvidersList;

const deliveryProvidersList = () =>
  createSelector([selectDeliveryProvidersList], (delivery) => delivery.data);

const deliveryProvidersListError = () =>
  createSelector([selectDeliveryProvidersList], (delivery) => delivery.error);

const deliveryProvidersListLoading = () =>
  createSelector([selectDeliveryProvidersList], (delivery) => delivery.loading);

module.exports = {
  createTransaction,
  createTransactionError,
  createTransactionLoading,

  getInvoice,
  getInvoiceError,
  getInvoiceLoading,

  getTransactions,
  getTransactionsError,
  getTransactionsLoading,

  getTransaction,
  getTransactionError,
  getTransactionLoading,

  updateAddress,
  updateAddressError,
  updateAddressLoading,

  cartChackout,
  cartChackoutError,
  cartChackoutLoading,

  transactionDelivery,
  transactionDeliveryError,
  transactionDeliveryLoading,

  deliveryPriceList,
  deliveryPriceListError,
  deliveryPriceListLoading,

  deliveryProvidersList,
  deliveryProvidersListError,
  deliveryProvidersListLoading,
};
